
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getWorkOrderApplicationStatus = async () => {
  return await get<ApiResponse<any[]>>("/workOrderApplicationStatus").then((res)=>{
      return res
    })
};

 